import Headroom from "headroom.js";
import { initSlider } from "./_slider";
//import { initFixedHeader } from "./_fixed-header";

var mobileThreshold = 992;
var isMobile = window.innerWidth < mobileThreshold;

const app = document.querySelector("#app");
const header = document.querySelector('.site-header');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    require("bootstrap");
} catch (e) {}

const headroom = new Headroom(document.querySelector(".site-header"), {
    // headroom options here
    // https://wicky.nillia.ms/headroom.js/

    // callback when pinned, `this` is headroom object
    onPin : function() { },
    // callback when unpinned, `this` is headroom object
    onUnpin : function() {},
    // callback when above offset, `this` is headroom object
    onTop : function() {
        jQuery('.navbar').addClass('navbar-light');
        jQuery('.navbar').addClass('bg-white');

        jQuery('.navbar').removeClass('navbar-dark');
        jQuery('.navbar').removeClass('bg-dark');

        jQuery('.navbar-brand .logo').addClass('d-block').removeClass('d-none');
        jQuery('.navbar-brand .logo-reverse').addClass('d-none').removeClass('d-block');
    },
    // callback when below offset, `this` is headroom object
    onNotTop : function() {
        jQuery('.navbar').removeClass('navbar-light');
        jQuery('.navbar').removeClass('bg-white');

        jQuery('.navbar').addClass('navbar-dark');
        jQuery('.navbar').addClass('bg-dark');

        jQuery('.navbar-brand .logo').addClass('d-none').removeClass('d-block');
        jQuery('.navbar-brand .logo-reverse').addClass('d-block').removeClass('d-none');

    },
    // callback when at bottom of page, `this` is headroom object
    onBottom : function() {},
    // callback when moving away from bottom of page, `this` is headroom object
    onNotBottom : function() {},

    tolerance : {
        up : 0,
        down : 0
    }
});


function onWindowResize() {
    // mobile width?
    isMobile = window.innerWidth < mobileThreshold;

    // Our header is positioned fixed, so let's offset the app element to the headers height
    headroom.offset = header.offsetHeight;
    app.style.paddingTop = `${header.offsetHeight}px`;
}

function addURLRedirect(element,url,target) {
    jQuery(element).on( "click", function() {
        window.location = url;
        //window.open(url, target);
    });
}

function initResourceToggle() {
    //console.log('init excerpt toggle');
    jQuery(".article-tease a.collapse-link").on( "click", function(target) {
        //var excerpt = $(target).parents('.article-tease').find('.excerpt-summary');
        var excerpt = jQuery(target.currentTarget).attr("aria-controls");
        var delay = 0;

        if(jQuery('.' + excerpt).is(":hidden")) {
            delay = 300;
            jQuery('.' + excerpt).delay( delay ).fadeIn();
        } else {
            jQuery('.' + excerpt).delay( delay ).hide();
        }
        
        //excerpt.toggle();
        //console.log(excerpt, delay);
    });
}

function toggleWelcomePanel() {
    const queryString = window.location.search;

    if(queryString.length > 0) {
        
        const urlParams = new URLSearchParams(queryString);
        let is_paged = urlParams.get('_paged');
        
        // toggle welcome panel if paging results
        if ( typeof is_paged !== 'undefined' && is_paged > 1 ) {
            jQuery('#resources-listing .welcome-panel').hide();
        } else {
            jQuery('#resources-listing .welcome-panel').show();
        }

    } else {
        jQuery('#resources-listing .welcome-panel').show();
    }

}

// inits
jQuery(function($) {
    headroom.init();
    onWindowResize();
    initSlider($);

	// debounce window resize
	var timeout = 0;
	$(window).on( 'resize', event => {
		clearTimeout(timeout);
		timeout = setTimeout( () => {
			onWindowResize();
		}, 300)
	});

    // Create event listener for all link clicks
    document.querySelectorAll('a:not(.collapse-link)').forEach(link => {
        link.addEventListener('click', (e) => {
            
            // Retrieve href and store in targetUrl variable
            try {
                let url = e.currentTarget.href;
                let domain = (new URL(url));
                let url_target = '_self';

                // check if url har target
                if (e.currentTarget.target.length > 1) {
                    url_target = e.currentTarget.target;
                }

                //console.log(url);
                if(domain != undefined) {
                    let link_domain = domain.hostname;
                    let int_domain = safe_domain; // safe_domain defined in WP Theme-Options > Scripts. Should match this site's url
                    let emp_domain = empowered_domain; // empowered_domain defined in WP Theme-Options > Scripts. Should match Empowered site url

                     // excluded_domain defined in WP Theme-Options > Scripts. Excluded from link checks.
                    let excl_domain = '';
                    if (excluded_domain.length > 1 && excluded_domain != undefined) {
                        excl_domain = excluded_domain;
                    } 

                    if (link_domain != excl_domain) {
                        if (int_domain != undefined && emp_domain != undefined && link_domain != int_domain) {
                            e.preventDefault();
                            
                            // link if to Empowered website
                            if (link_domain == emp_domain) {
                                jQuery('#link-redirect-internal').modal('show');
                                addURLRedirect('#link-redirect-internal .follow-redirect',url,url_target); // internal redirect
                            } else { // link to external 
                                jQuery('#link-redirect-external').modal('show');
                                addURLRedirect('#link-redirect-external .follow-redirect',url,url_target); // external redirect
                            }
                            
                            // Output value of targetUrl to console
                            //console.log('A link with target URL ' + url + 'was clicked. Domain: ' + link_domain);
                            //console.log(safe_domain);
                        } else {
                            console.log("Define values for 'safe_domain' and 'empowered_domain' in Theme Options > Scripts");
                        }
                    }
                }
                
            } catch (error) {
                console.log( "ERROR: " + error);
            }              
            
        });
    });

    //initResourceToggle();

    document.addEventListener('facetwp-refresh', function() {
        //console.log('refresh facets');
        const addResourceToggle = setTimeout(initResourceToggle, 500);
        //initResourceToggle();
        //toggleWelcomePanel()
        const addWelcomeToggle = setTimeout(toggleWelcomePanel, 500);
       
    
        //console.log(FWP_HTTP.get);
    });

});
